import * as types from './constants';

export const submitModal = (modalId, payload = {}) => ({
    types: [
        types.SUBMIT_MODAL_REQUEST,
        types.SUBMIT_MODAL_SUCCESS,
        types.SUBMIT_MODAL_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modals/${modalId}`,
            method: 'POST',
            body: payload
        }),
});

export const declineModal = (modalId, payload = {}) => ({
    types: [
        types.DECLINE_MODAL_REQUEST,
        types.DECLINE_MODAL_SUCCESS,
        types.DECLINE_MODAL_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/modals/${modalId}/decline`,
            method: 'POST',
            body: payload
        }),
});
